import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Field} from 'redux-form';

const Wrapper = styled.div`
  position: relative;
  margin: 10px 0;
  min-width: 260px;
  flex: 1 1 auto;
`;


export const InputElement = styled.input`
  height: 45px;
  @-moz-document url-prefix() {
    &{
      height: auto;
    }
  }
  width: 100%;
  display: block;
 
  box-shadow: none;
  padding: 8px 16px;
  line-height: 1.2;
  border: solid 1px #b3b3b3;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  margin-top: ${props => props.bottom ? "7px" : "5px"};
  font-size: ${props => props.fontSize || '16px'};
  border: ${props => props.hasError ? "1px solid #7f1414" : ""};
  @media (max-width: 480px){
    font-size: 14px;
  }


  &:focus {
    border: solid 1px #ecbc2b;
    box-shadow: none;
    outline: 0 !important;
    color: #2c2c2c;
    transition: all 0.30s ease-in-out;
  }
`;

const LabelElement = styled.label`
  font-size: 12px;
  color: ${props => props.hasError ? "#7f1414" : ""};

  span {
    display: ${props => props.required ? "inline-block" : "none"};
    color: ${props => props.required ? "#edbd2f" : "#fff"};
    padding-left: ${props => props.required ? "4px" : "4px"};
    color: ${props => props.hasError ? "#7f1414" : ""};
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HintWrapper = styled.div`
  font-size: 12px;
  color: #7f1414;
`;

const ErrorField = styled.span`
  position: absolute;
  right: 1%;
  top: 110%;
  color: #edbd2f;
  letter-spacing: 0.4px;
`

const Input = (props) => {

  const renderErrorBlock = () => (props.errMsg && props.hasError) && <ErrorField>{props.errMsg}</ErrorField>

  return (
    <Wrapper block={props.block} hasError={props.hasError}>
      <LabelWrapper>
        <LabelElement required={props.required}>{props.label}<span>*</span></LabelElement>
        <HintWrapper>{props.hintMsg}</HintWrapper>
      </LabelWrapper>
      <InputElement type={props.type} required={props.required} className={props.inputClassName} multiple={props.multiple}
        accept={props.accept} checked={props.checked} value={props.value} disabled={props.disabled} minLength={props.min}
        onChange={props.onChange} onFocus={props.onFocus} onBlur={props.onBlur} placeholder={props.placeholder} hasError={props.hasError} maxLength={props.max} pattern={props.pattern} bottom={props.bottom}
      />
      {renderErrorBlock()}
    </Wrapper>
  )
}

Input.defaultProps = {
  type: 'text'
};

Input.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func
};

export const FieldInput = Wrapper.withComponent(Field)
export default Input;




// WEBPACK FOOTER //
// ./src/form/input.js